import { OfferTitleProps } from './OfferTitle.types';

export const OfferTitle = ({ title }: OfferTitleProps) => {
  return (
    <div className='profile-info-header flex justify-between items-center'>
      <div className='title text-xl font-bold'>{title}</div>
    </div>
  );
};
